import { SCHEDULE_SOURCE_TEST_ID } from '../StartNodeEditor.constants';
import { EntrySourceContainer } from '../StartNodeEditor.styled';
import { EntrySourceComponentProps } from '../StartNodeEditor.types';
import { DefineAudienceSelect } from './DefineAudienceSelect';
import { SchedulerForm } from './Scheduler';

/**
 * Visit the [slab documentation](https://iterable.slab.com/posts/start-tile-editor-components-wlds1ru4#hxfbz-schedule-recurring-list)
 * for more information on Schedule Recurring List trigger
 */
export const ScheduleEntrySource = ({
  displayValue,
  hasCloningError,
}: EntrySourceComponentProps) => {
  return (
    <EntrySourceContainer data-test={SCHEDULE_SOURCE_TEST_ID}>
      <DefineAudienceSelect displayValue={displayValue} hasCloningError={hasCloningError} />
      <SchedulerForm />
    </EntrySourceContainer>
  );
};
